import { forwardRef, useEffect, useState } from 'react';
import { Icon } from '@mui/material';
import { Error, Lens } from '@mui/icons-material';

export type statusClassState = 'success' | 'warning' | 'alert' | null;

export type GenericStatusIconProps = {
    status: statusClassState;
};

const ratingClassToIcon = (ratingClass: string | null) => {
    switch (ratingClass) {
        case 'success':
        case 'warning':
            return <Lens fontSize="inherit" data-testid="LensIcon" />;
        case 'alert':
        default:
            return <Error fontSize="inherit" data-testid="ErrorIcon" />;
    }
};

const ratingClassToIconColor = (ratingClass: string | null) => {
    switch (ratingClass) {
        case 'success':
            return '#31a354';
        case 'warning':
            return '#ffae00';
        case 'alert':
            return '#FF5722';
        default:
            return '';
    }
};

export const GenericStatusIcon = forwardRef(
    ({ status }: GenericStatusIconProps, _ref) => {
        const [icon, setIcon] = useState(<div />);
        const [color, setColor] = useState('');

        useEffect(() => {
            setIcon(ratingClassToIcon(status));
            setColor(ratingClassToIconColor(status));
        }, [status]);

        return (
            <div data-testid="GenericStatusIcon">
                <Icon sx={{ color: color, fontSize: '16pt' }}>{icon}</Icon>
            </div>
        );
    }
);
// Silences an eslint warning when using forwardRef
GenericStatusIcon.displayName = 'GenericStatusIcon';
